import { ConfirmWrap, CheckCircle, ConfirmTitle, ConfirmBody } from './styles';

export function ConfirmationPage({ venueShortName }) {
  return (
    <ConfirmWrap>
      <CheckCircle aria-hidden="true">✓</CheckCircle>
      <ConfirmTitle>Agreement submitted</ConfirmTitle>
      <ConfirmBody>
        Thanks — we've received the venue agreement for{' '}
        <span style={{ color: '#fff' }}>{venueShortName}</span>. Our team will review your details
        and be in touch to finalise your account for gift card redemption payouts.
      </ConfirmBody>
    </ConfirmWrap>
  );
}

export function AlreadySubmittedPage() {
  return (
    <ConfirmWrap>
      <CheckCircle aria-hidden="true" style={{ background: '#7a5c00' }}>!</CheckCircle>
      <ConfirmTitle>Already processed</ConfirmTitle>
      <ConfirmBody>
        Agreement already processed for this venue. If you think this is a mistake, please contact
        our support team.
      </ConfirmBody>
    </ConfirmWrap>
  );
}
